import React from "react";
import { Card, BlockStack, InlineStack, Text, Button, Link } from "@shopify/polaris";

const SUPPORT_EMAIL = "support@productessentials.app";

const HelpCard = ({ openSupportBeacon = () => {} }) => (
  <Card>
    <BlockStack gap="200">
      <Text as="h2" variant="headingSm">Need help?</Text>
      <Text as="p" variant="bodySm" tone="subdued">
        Live chat weekdays 9–17 CET; otherwise we reply within 24 hours.
      </Text>
      <InlineStack>
        <Button onClick={openSupportBeacon}>Chat with us</Button>
      </InlineStack>
      <Link url="https://productessentials.helpscoutdocs.com/article/45-creating-a-sale-with-widgets-and-landing-page" target="_blank">
        Quick start guide
      </Link>
      <Link url="https://productessentials.app/getting-started" target="_blank">5-minute tutorial</Link>
      <Link url={`mailto:${SUPPORT_EMAIL}`} target="_blank">{SUPPORT_EMAIL}</Link>
    </BlockStack>
  </Card>
);

export default HelpCard;
